import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { FiArrowUpRight } from "react-icons/fi";
import ProjectMedia from "../ProjectMedia/ProjectMedia";
import "./ProjectCard.scss";

const ProjectCard = ({ project, size = "default", headingLevel = "h3" }) => {
  const Heading = headingLevel;
  const tags = project.stack.length ? project.stack.slice(0, 3) : [];
  return (
    <article className={`project-card project-card--${size}`}>
      <ProjectMedia project={project} />
      <div className="project-card__body">
        <div className="project-card__meta">
          <span className="tag tag--accent">{project.category}</span>
          {project.confidential && <span className="tag">Confidential client</span>}
          {project.inProgress && <span className="tag">In development</span>}
          {project.playUrl && <span className="tag">Google Play</span>}
          {project.liveUrl && <span className="tag">Live site</span>}
        </div>
        <Heading className="project-card__title">
          <Link to={`/projects/${project.slug}`} className="project-card__link">
            {project.name}
          </Link>
        </Heading>
        <p className="project-card__tagline">{project.tagline}</p>
        {tags.length > 0 && (
          <ul className="tag-list project-card__stack" aria-label="Tech stack">
            {tags.map((t) => (
              <li key={t} className="tag">
                {t}
              </li>
            ))}
            {project.stack.length > 3 && (
              <li className="tag">+{project.stack.length - 3}</li>
            )}
          </ul>
        )}
        <span className="project-card__cta" aria-hidden="true">
          View case study <FiArrowUpRight />
        </span>
      </div>
    </article>
  );
};

ProjectCard.propTypes = {
  project: PropTypes.object.isRequired,
  size: PropTypes.oneOf(["default", "large"]),
  headingLevel: PropTypes.oneOf(["h2", "h3"]),
};

export default ProjectCard;
